import './Schedule.css';

const DAY_MAP = {
  'понедельник': 1,
  'вторник': 2,
  'среда': 3,
  'четверг': 4,
  'пятница': 5,
  'суббота': 6,
};

const timeToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

const hasNoPairs = (days) =>
  days.every((day) => day.pairs.every((pair) => pair.subject === 'Пар на этой неделе нет'));

const defaultPairMeta = (pair) => (
  <>
    <p className='teacher'>Преподаватель: {pair.teacher}</p>
    <div className='pair-meta'>
      <span className='pair-type'>{pair.pair_type}</span>
      <span className='classroom'>Аудитория: {pair.class_room}</span>
    </div>
  </>
);

function DayColumn({ day, today, currentTime, renderPairMeta }) {
  const dayNumber = DAY_MAP[day.day_week.toLowerCase()];
  const isCurrentDay = dayNumber === today;

  return (
    <div key={day.date} className='day-container'>
      <div className={`day-header ${isCurrentDay ? 'current-day' : ''}`}>
        <h2>{day.day_week.toUpperCase()}</h2>
        <h3>{day.date}</h3>
      </div>

      <div className='pairs-container'>
        {day.pairs.map((pair) => {
          const pairStart = timeToMinutes(pair.time_start);
          const pairEnd = timeToMinutes(pair.time_end);
          const isCurrentPair = isCurrentDay && currentTime >= pairStart && currentTime <= pairEnd;

          return (
            <div key={`${day.date}-${pair.pair}`} className={`pair-container ${isCurrentPair ? 'current-pair' : ''}`}>
              <div className='pair-header'>
                <div className='pair-number'>{pair.pair} пара</div>
                <div className='pair-time'>{pair.time_start} - {pair.time_end}</div>
              </div>

              <div className='pair-details'>
                <h5>{pair.subject}</h5>
                {renderPairMeta(pair)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ScheduleCard({
  scheduleData,
  itemKey = 'group_name',
  itemTitle = (item) => item.group_name,
  renderPairMeta = defaultPairMeta,
}) {
  if (!scheduleData) return null;

  const now = new Date();
  const today = now.getDay();
  const currentTime = now.getHours() * 60 + now.getMinutes();

  const sortedData = [...scheduleData].sort((a, b) => hasNoPairs(a.days) - hasNoPairs(b.days));

  return (
    <div className='schedule-container'>
      {sortedData.map((item, index) => {
        const itemId = item[itemKey] ?? item.group_name ?? item.teacher ?? item.class_room ?? item.classroom ?? index;

        return (
          <div key={itemId} className="group-schedule">
            <div className='group-header'>
              <h1>{itemTitle(item)}</h1>
            </div>

            <div className='days-grid'>
              {item.days.map((day) => (
                <DayColumn
                  key={`${itemId}-${day.date}`}
                  day={day}
                  today={today}
                  currentTime={currentTime}
                  renderPairMeta={renderPairMeta}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export { DAY_MAP, timeToMinutes, hasNoPairs };
export default ScheduleCard;
